// extracted by mini-css-extract-plugin
module.exports = {"content":"AccordionFragment_content___MoAc"};